import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
// import { Link } from 'react-router-dom';
import { publicRouteLink } from "../constant/Routes";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { MainContext } from "../context/main";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../config/api";

export const ChangeNumber = () => {
  const [ph, setPh] = useState("");
  const { countryCode, setCountryCode, mob, setMob } = useContext(MainContext);
  const navigate = useNavigate();

  useEffect(() => {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = () => {
      toast.error("Unauthorized access. Redirecting...");
      navigate(publicRouteLink.SIGNIN, { replace: true });
    };
  }, []);

  // const handlePhChange = (phone, country) => {
  //   const newPh = phone.split(country.dialCode);
  //   setPh(phone);
  //   setMob(newPh[1]);
  //   setCountryCode(country.dialCode);
  // };

  const handlePhChange = (phone, country) => {
    let newPh;

    // Check if the number starts with '91' (without a '+')
    if (phone.startsWith("91") && !phone.startsWith("+91")) {
      console.log("Detected number starting with '91' without country code");
      newPh = phone.slice(2); // Remove the leading '91'
    } else {
      // Default logic to split by country code
      newPh = phone.split(country.dialCode)[1] || "";
    }

    newPh = newPh.replace(/\D/g, ""); // Remove any non-numeric characters
    // console.log("Processed Phone Number:", newPh);

    // Update state
    setPh(phone);
    setMob(newPh);
    setCountryCode(country.dialCode);
  };

  const sendOTP = async () => {

    try {
      const url = `${API_BASE_URL}/v2/send-otp`;

      const resp = await axios({
        url: url,
        method: "POST",
        headers: {
          "Content-type": "application/json",
        },
        data: {
          email: "",
          mob: mob,
          countryCode: "+" + countryCode,
        },
      });

      if (resp.data.result.statusCode === 200) {
        toast.success("OTP sent successfully!");
        navigate(publicRouteLink.OTP_VERIFICATION);
      } else {
        toast.error("OTP not sent. Please try again!");
      }
    } catch (error) {
      console.log("Error from sendOTP function:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  const checkPhoneNumber = async () => {
    if (!mob || mob === "") {
      toast.error("Please enter a valid phone number.");
      return;
    }
  
    // if (mob.length < 10) {
    //   toast.error("Phone number must be at least 10 digits.");
    //   return;
    // }
    try {
      const response = await fetch(
        `${API_BASE_URL}/v1/CheckPhoneNo/${mob}`
      );

      const data = await response.json();
      if (data.status === 200) {
        sendOTP();
      } else if (data.status === 409) {
        toast.error("Phone number already exists. Please log in.");
      } else {
        toast.error("Unexpected phone check response. Try again.");
      }
    } catch (error) {
      console.error("Check Phone Error:", error);
      toast.error("Error checking phone number. Try again later.");
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen px-4">
       <div className="flex flex-col lg:flex-row bg-white rounded-[4%] items-center lg:items-start">
       <div className="w-80 mt-16 pl-8 pr-8 lg:pr-0 lg:w-80 lg:pl-12 lg:mt-24 ">
       <h2 className="text-2xl lg:text-3xl font-semibold mb-8 mr-4 lg:mb-6 text-[#FF6C2F]">
            Change phone number
          </h2>
          <p className="text-[#181818] text-sm font-medium mb-2 mt-4 break-words">
            Please enter a valid phone number
          </p>
          <PhoneInput
            inputClass="w-full"
            country={"in"}
            value={ph}
            onChange={handlePhChange}
            required
            className="text-black"
          />

          <button
            className="bg-[#FF6C2F] text-white text-sm font-normal px-4 py-2 mt-4 mb-16 rounded-md w-full lg:w-full h-12"
            onClick={checkPhoneNumber}
          >
            Send code
          </button>
          {/* <Link to={publicRouteLink.OTP_VERIFICATION}>
                        <button className="bg-[#FF6C2F] text-white text-sm font-normal px-4 py-2 mb-8 mt-4 rounded-md w-80 h-12"
                            onClick={handleClick}
                        >
                            Send code
                        </button>
                    </Link> */}
        </div>  

        <div className="hidden lg:block mt-6 lg:mt-0 lg:ml-16 ">
          <img
            src="assets\verification-pic.png"
            alt="verification-pic"
            className="w-64 lg:w-auto"
          />
        </div>
      </div>
    </div>
  );
};
